module.exports = __webpack_public_path__ + "media/images/championship__iconPickTeam--plain-8fc88f48ae06051518aeec0321e3652a.png";